import { render, staticRenderFns } from "./produkkredit.vue?vue&type=template&id=90172a02&scoped=true&"
import script from "./produkkredit.vue?vue&type=script&lang=js&"
export * from "./produkkredit.vue?vue&type=script&lang=js&"
import style0 from "./produkkredit.vue?vue&type=style&index=0&id=90172a02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90172a02",
  null
  
)

export default component.exports